import React from 'react';
import { notEnoughSection } from '../data/copy';
export function NotEnoughSection() {
  return <section className="border-y border-white/10 bg-pf-navy px-3 py-3 text-white sm:px-4 sm:py-4" data-id="element-108" data-mp="oezv1iyd4eb5">
      <div className="mx-auto max-w-4xl text-center" data-id="element-109" data-mp="jfwry41y0i5t">
        <h2 className="mb-1 font-display text-xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-4xl" data-id="element-110" data-mp="jiix5x1d2lkv">
          {notEnoughSection.title}
        </h2>
        <div className="mx-auto max-w-3xl space-y-0.5 text-[12.5px] font-medium leading-snug text-white/80 sm:text-base" data-id="element-111" data-mp="1c4lt23300nhk">
          {notEnoughSection.intro.map(line => <p key={line} data-id="element-112" data-mp="12eiqbb62rv61">{line}</p>)}
        </div>

        <p className="mt-1 font-display text-[13px] font-bold uppercase tracking-wide text-pf-gold sm:text-lg" data-id="element-113" data-mp="ydp2siwjoido">
          {notEnoughSection.needLabel}
        </p>
        <ul className="mx-auto mb-1.5 mt-0.5 flex max-w-3xl flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-[12px] font-bold text-white sm:text-[15px]" data-id="element-114" data-mp="1ux65k9ye4fz7">
          {notEnoughSection.needs.map(need => <li key={need} data-id="element-115" data-mp="2mtsd6eshpz3i">{need}</li>)}
        </ul>

        <div className="mx-auto max-w-3xl space-y-0.5 text-[12.5px] font-medium leading-snug text-white/80 sm:text-base" data-id="element-116" data-mp="2rpqzzxy6791t">
          <p data-id="element-117" data-mp="2d1mcmgo6a9cp">{notEnoughSection.close[0]}</p>
          <p className="font-bold text-white" data-id="element-118" data-mp="2i0pjm6npqpnb">{notEnoughSection.close[1]}</p>
        </div>
      </div>
    </section>;
}